import { Toaster as SonnerToaster, toast as sonnerToast } from "sonner";

export const Toaster = SonnerToaster;
export const toast = sonnerToast;
